/* Extranet & Login translations */
export const extranetTranslations = {
  fr: {
    ext: {
      // Header
      headerBtn: 'Extranet',
      // Login page
      backHome: "Retour à l'accueil",
      loginTitle: 'Espace Privé',
      loginSubtitle: 'Accès réservé aux producteurs partenaires',
      username: "Nom d'usager",
      usernamePh: 'votre-usager',
      password: 'Mot de passe',
      passwordPh: '••••••••',
      signIn: 'Se connecter',
      signingIn: 'Connexion…',
      welcomeToast: 'Connexion réussie',
      welcomeToastDesc: 'Bienvenue',
      errorTitle: 'Erreur',
      loginError: 'Impossible de se connecter.',
      noAccess: "Pas encore d'accès ? Contactez Yuville à",
      // Extranet page
      privateSpace: 'Espace Privé • Extranet Producteurs',
      welcome: 'Bienvenue',
      yourCommodities: 'Vos matières autorisées :',
      admin: 'Admin',
      logout: 'Déconnexion',
      sectionPrefix: 'Section',
      documentsFor: 'Documents',
      noDocuments: 'Aucun document.',
      deposit: 'Déposer un document',
      depositIntro: 'Le document sera rattaché à la section',
      depositIntro2: 'Denis recevra une notification par courriel.',
      titleFieldPh: 'Titre du document *',
      descPh: 'Description (optionnelle)',
      depositBtn: 'Déposer le document',
      sending: 'Envoi…',
      successTitle: 'Dépôt réussi',
      successDesc: 'Denis a été notifié par courriel.',
      uploadError: 'Upload impossible.',
      requiredFields: 'Champs requis',
      requiredFieldsDesc: 'Titre et fichier requis.',
      myUploads: 'Mes dépôts',
      noUploads: 'Aucun dépôt dans cette section.',
      delete: 'Supprimer',
      confirmDelete: 'Supprimer ce document ?',
      downloadErr: 'Téléchargement impossible.',
      // Empty state
      noCommodityTitle: 'Aucune matière assignée',
      noCommodityDesc: "Votre compte n'a pas encore d'accès à une matière première. Contactez Denis à",
      noCommodityDesc2: 'pour obtenir l\'accès.',
      // Categories
      catLoi: 'Letter of Interest (LOI)',
      catIcpo: 'ICPO',
      catBanking: 'Coordonnées bancaires',
      catPassport: 'Passeports',
      catLicense: "Licences d'exploitation",
      catOther: 'Autres documents',
      // Producer access card (shown on Trading page / homepage)
      pa_titleShort: 'Espace privé producteurs',
      pa_titleLong: 'Espace privé pour les producteurs partenaires',
      pa_descShort_pre: 'Accès sécurisé réservé aux producteurs partenaires de Yuville. Consultez les ',
      pa_descShort_docs: 'LOI, ICPO',
      pa_descShort_mid: ', les ',
      pa_descShort_bank: 'coordonnées bancaires',
      pa_descShort_pass: 'passeports',
      pa_descShort_lic: "licences d'exploitation",
      pa_descShort_and: ' et ',
      pa_descShort_of: ' de Yuville et de Qianyan, et déposez vos propres documents en toute confidentialité.',
      pa_descLong: 'Un extranet sécurisé où nos partenaires actuels accèdent aux documents confidentiels de Yuville et Qianyan et peuvent déposer leurs propres fichiers.',
      pa_bullet1: 'Documents confidentiels de Yuville & Qianyan',
      pa_bullet2: 'Modèles LOI et ICPO téléchargeables (PDF)',
      pa_bullet3: 'Dépôt sécurisé de vos analyses et certificats',
      pa_bullet4: 'Notification directe à Denis Villeneuve',
      pa_bullet_loi: 'Letter of Interest (LOI) au format PDF',
      pa_bullet_icpo: 'ICPO officiel Yuville / Qianyan',
      pa_bullet_bank: 'Coordonnées bancaires et licences',
      pa_bullet_pass: 'Copies de passeports vérifiés',
      pa_bullet_upload: 'Dépôt sécurisé de vos documents',
      pa_ctaEnter: "Accéder à l'extranet",
      pa_ctaSignIn: 'Se connecter',
      pa_contactLock: "Pas encore d'accès ? Contactez",
      pa_contactPlain: 'Contact :',
    },
  },
  en: {
    ext: {
      headerBtn: 'Extranet',
      backHome: 'Back to home',
      loginTitle: 'Private Area',
      loginSubtitle: 'Reserved for producer partners',
      username: 'Username',
      usernamePh: 'your-username',
      password: 'Password',
      passwordPh: '••••••••',
      signIn: 'Sign in',
      signingIn: 'Signing in…',
      welcomeToast: 'Signed in',
      welcomeToastDesc: 'Welcome',
      errorTitle: 'Error',
      loginError: 'Unable to sign in.',
      noAccess: 'No access yet? Contact Yuville at',
      privateSpace: 'Private Area • Producer Extranet',
      welcome: 'Welcome',
      yourCommodities: 'Your authorized commodities:',
      admin: 'Admin',
      logout: 'Log out',
      sectionPrefix: 'Section',
      documentsFor: 'Documents',
      noDocuments: 'No documents.',
      deposit: 'Upload a document',
      depositIntro: 'The document will be attached to the',
      depositIntro2: 'section. Denis will be notified by email.',
      titleFieldPh: 'Document title *',
      descPh: 'Description (optional)',
      depositBtn: 'Upload document',
      sending: 'Sending…',
      successTitle: 'Upload successful',
      successDesc: 'Denis has been notified by email.',
      uploadError: 'Upload failed.',
      requiredFields: 'Required fields',
      requiredFieldsDesc: 'Title and file are required.',
      myUploads: 'My uploads',
      noUploads: 'No uploads in this section.',
      delete: 'Delete',
      confirmDelete: 'Delete this document?',
      downloadErr: 'Download failed.',
      noCommodityTitle: 'No commodity assigned',
      noCommodityDesc: 'Your account has no access to any commodity yet. Contact Denis at',
      noCommodityDesc2: 'to get access.',
      catLoi: 'Letter of Interest (LOI)',
      catIcpo: 'ICPO',
      catBanking: 'Banking details',
      catPassport: 'Passports',
      catLicense: 'Business licenses',
      catOther: 'Other documents',
      pa_titleShort: 'Private producer area',
      pa_titleLong: 'Private area for producer partners',
      pa_descShort_pre: 'Secure access reserved for Yuville producer partners. Consult ',
      pa_descShort_docs: 'LOI, ICPO',
      pa_descShort_mid: ', ',
      pa_descShort_bank: 'banking details',
      pa_descShort_pass: 'passports',
      pa_descShort_lic: 'business licenses',
      pa_descShort_and: ' and ',
      pa_descShort_of: ' from Yuville and Qianyan, and upload your own documents in full confidentiality.',
      pa_descLong: 'A secure extranet where our current partners access confidential Yuville and Qianyan documents and can upload their own files.',
      pa_bullet1: 'Confidential Yuville & Qianyan documents',
      pa_bullet2: 'Downloadable LOI and ICPO templates (PDF)',
      pa_bullet3: 'Secure upload of your analyses and certificates',
      pa_bullet4: 'Direct notification to Denis Villeneuve',
      pa_bullet_loi: 'Letter of Interest (LOI) as PDF',
      pa_bullet_icpo: 'Official Yuville / Qianyan ICPO',
      pa_bullet_bank: 'Banking details and licenses',
      pa_bullet_pass: 'Verified passport copies',
      pa_bullet_upload: 'Secure upload of your documents',
      pa_ctaEnter: 'Enter the extranet',
      pa_ctaSignIn: 'Sign in',
      pa_contactLock: 'No access yet? Contact',
      pa_contactPlain: 'Contact:',
    },
  },
  zh: {
    ext: {
      headerBtn: '外联网',
      backHome: '返回首页',
      loginTitle: '私人专区',
      loginSubtitle: '仅限合作生产商访问',
      username: '用户名',
      usernamePh: '您的用户名',
      password: '密码',
      passwordPh: '••••••••',
      signIn: '登录',
      signingIn: '登录中…',
      welcomeToast: '登录成功',
      welcomeToastDesc: '欢迎',
      errorTitle: '错误',
      loginError: '无法登录。',
      noAccess: '还没有访问权限？请联系 Yuville',
      privateSpace: '私人专区 • 生产商外联网',
      welcome: '欢迎',
      yourCommodities: '您的授权大宗商品：',
      admin: '管理员',
      logout: '退出登录',
      sectionPrefix: '专区',
      documentsFor: '文件',
      noDocuments: '暂无文件。',
      deposit: '上传文件',
      depositIntro: '该文件将附加到',
      depositIntro2: '专区。Denis 将通过电子邮件收到通知。',
      titleFieldPh: '文件标题 *',
      descPh: '描述（可选）',
      depositBtn: '上传文件',
      sending: '发送中…',
      successTitle: '上传成功',
      successDesc: 'Denis 已通过电子邮件收到通知。',
      uploadError: '上传失败。',
      requiredFields: '必填字段',
      requiredFieldsDesc: '标题和文件为必填项。',
      myUploads: '我的上传',
      noUploads: '此专区暂无上传。',
      delete: '删除',
      confirmDelete: '删除此文件？',
      downloadErr: '下载失败。',
      noCommodityTitle: '未分配大宗商品',
      noCommodityDesc: '您的账户尚未获得任何大宗商品的访问权限。请联系 Denis',
      noCommodityDesc2: '获取访问权限。',
      catLoi: '意向书 (LOI)',
      catIcpo: 'ICPO',
      catBanking: '银行信息',
      catPassport: '护照',
      catLicense: '营业执照',
      catOther: '其他文件',
      pa_titleShort: '生产商私人专区',
      pa_titleLong: '生产商合作伙伴私人专区',
      pa_descShort_pre: '仅限 Yuville 合作生产商的安全访问。查阅 ',
      pa_descShort_docs: 'LOI、ICPO',
      pa_descShort_mid: '、',
      pa_descShort_bank: '银行信息',
      pa_descShort_pass: '护照',
      pa_descShort_lic: '营业执照',
      pa_descShort_and: ' 及 ',
      pa_descShort_of: '（来自 Yuville 与 Qianyan），并以完全保密的方式上传您自己的文件。',
      pa_descLong: '一个安全的外联网，现有合作伙伴可访问 Yuville 与 Qianyan 的机密文件，并上传自己的文件。',
      pa_bullet1: 'Yuville 与 Qianyan 机密文件',
      pa_bullet2: '可下载的 LOI 与 ICPO 模板（PDF）',
      pa_bullet3: '安全上传您的分析报告与证书',
      pa_bullet4: '直接通知 Denis Villeneuve',
      pa_bullet_loi: 'PDF 格式的意向书 (LOI)',
      pa_bullet_icpo: 'Yuville / Qianyan 官方 ICPO',
      pa_bullet_bank: '银行信息与许可证',
      pa_bullet_pass: '已核实的护照复印件',
      pa_bullet_upload: '安全上传您的文件',
      pa_ctaEnter: '进入外联网',
      pa_ctaSignIn: '登录',
      pa_contactLock: '还没有访问权限？请联系',
      pa_contactPlain: '联系方式：',
    },
  },
};
